import { Link } from "react-router"
import { useTranslation } from "react-i18next"
import { CheckCircle2Icon, CircleIcon } from "lucide-react"

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/cn"
import type { Checklist, StepId } from "../lib/overview"

const TO: Record<StepId, string> = {
  device: "/devices",
  key: "/api-keys",
  message: "/messages/new",
}

/** FR-DSH-OVW-06: the three first steps, until each is done (counts, DW-04). */
export function GetStarted({ list }: { list: Checklist }) {
  const { t } = useTranslation("overview")
  if (!list.visible) return null
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <h2 className="text-base font-semibold">{t("getStarted.title")}</h2>
        </CardTitle>
        <CardDescription>{t("getStarted.body")}</CardDescription>
      </CardHeader>
      <CardContent>
        <ol className="grid gap-2 sm:grid-cols-3">
          {list.steps.map((s) => (
            <li key={s.id}>
              <Link
                to={TO[s.id]}
                className={cn(
                  "flex min-h-11 items-center gap-2 rounded-md border border-border px-3 py-2 text-sm hover:bg-muted",
                  s.done && "text-muted-foreground",
                )}
              >
                {s.done ? (
                  <CheckCircle2Icon className="size-4 shrink-0 text-success" aria-hidden />
                ) : (
                  <CircleIcon className="size-4 shrink-0 text-muted-foreground" aria-hidden />
                )}
                <span>{t(`getStarted.${s.id}`)}</span>{" "}
                <span className="sr-only">
                  ({s.done ? t("getStarted.done") : t("getStarted.todo")})
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  )
}
